module.exports = [
  { id: '611', abbreviation: 'NSW', value: 'AU: New South Wales', countryId: '6000' },
  { id: '612', abbreviation: 'QLD', value: 'AU: Queensland', countryId: '6000' },
  { id: '613', abbreviation: 'VIC', value: 'AU: Victoria', countryId: '6000' },
  { id: '614', abbreviation: 'TAS', value: 'AU: Tasmania', countryId: '6000' },
  { id: '615', abbreviation: 'WA', value: 'AU: Western Australia', countryId: '6000' },
  { id: '616', abbreviation: 'SA', value: 'AU: South Australia', countryId: '6000' },
  { id: '617', abbreviation: 'ACT', value: 'AU: Australian Capital Territory', countryId: '6000' },
  { id: '618', abbreviation: 'NT', value: 'AU: Northern Territory', countryId: '6000' },
  { id: '619', abbreviation: 'NTI', value: 'NZ: North Island', countryId: '6001' },
  { id: '620', abbreviation: 'STI', value: 'NZ: South Island', countryId: '6001' },
  { id: '621', abbreviation: 'SWI', value: 'NZ: Stewart Island', countryId: '6001' },
  { id: '622', abbreviation: 'CTI', value: 'NZ: Chatham Islands', countryId: '6001' },
];
